module.exports = __webpack_public_path__ + "static/media/viewArrow.929a9406.svg";